var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.isVisible)?_c('div',{staticClass:"reactions"},_vm._l((_setup.reactions),function(item,index){return _c('div',{key:index,staticClass:"reaction",style:({ left: `calc(${_setup.calculateReactionPosition(item)}% - 10px)` })},[_c(_setup.ArticleTimelineReaction,{attrs:{"reaction":item}})],1)}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }